/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Language_SubtitleInputs */

const en_common_language_subtitle = /** @type {(inputs: Common_Language_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose English or Spanish`)
};

const es_common_language_subtitle = /** @type {(inputs: Common_Language_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige inglés o español`)
};

/**
* | output |
* | --- |
* | "Choose English or Spanish" |
*
* @param {Common_Language_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_language_subtitle = /** @type {((inputs?: Common_Language_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Language_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_language_subtitle(inputs)
	return en_common_language_subtitle(inputs)
});